import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cookie-consent',
  templateUrl: './cookie-consent.component.html',
  styleUrls: ['./cookie-consent.component.css']
})
export class CookieConsentComponent implements OnInit {
  showConsent = false;

  ngOnInit(): void {
    if (!localStorage.getItem('cookie_consent')) {
      this.showConsent = true;
    }
  }

  accept(): void {
    localStorage.setItem('cookie_consent', 'accepted');
    this.showConsent = false;
  }

  decline(): void {
    localStorage.setItem('cookie_consent', 'declined');
    this.showConsent = false;
  }
}
